<h2 mat-dialog-title>Kontakt setzen</h2>

<mat-dialog-content class="dialog-content">
    <p>
        Es werden {{ data?.tiere?.length || 0 }} ausgewählte Tiere aktualisiert.
    </p>

    <section class="auswahl-section">
        <kiene-betriebskontakt-auswahl
            [config]="{
                showLandwirte: true,
                showHaendler: true,
                showSchlachthoefe: true,
                showAll: true,
                multiSelect: false,
                compact: true,
                title: 'Kontakt auswählen',
                placeholder: 'Kontakt suchen...'
            }"
            [selectedKontakte]="selectedKontakt ? [selectedKontakt] : []"
            (kontaktSelected)="onKontaktSelected($event)"
            (kontakteSelected)="onKontakteSelected($event)"
        >
        </kiene-betriebskontakt-auswahl>

        <section *ngIf="selectedKontakt" class="selected-card">
            <h4>Ausgewählter Kontakt</h4>
            <kiene-betriebskontakt-card
                [kontakt]="selectedKontakt"
                [config]="{
                    showActions: false,
                    showMenu: false,
                    showFavorit: false,
                    compact: true,
                    showBadge: false,
                    selectedMode: true
                }"
            >
            </kiene-betriebskontakt-card>
        </section>
        <p class="hinweis-text">Wenn kein Kontakt ausgewählt ist, wird der bisherige Kontakt entfernt.</p>
    </section>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="cancel()" [disabled]="isSaving">Abbrechen</button>
    <button mat-flat-button color="primary" (click)="save()" [disabled]="isSaving">
        <mat-spinner *ngIf="isSaving" diameter="20"></mat-spinner>
        <span *ngIf="!isSaving">Speichern</span>
    </button>
</mat-dialog-actions>



